import { Color } from "@repo/app-types/constants/colors";
import {
  greenRedYellowResultTypeCategory,
  type OutcomeResultDefinition,
} from "@repo/app-types/entities/outcome";
import type { FC } from "react";
import type { Size } from "../helpers/helpers.js";
import { Pill, type PillColor } from "./pill.js";

// Map outcome categories to pill colors
const categoryToPillColor: Record<string, PillColor> = {
  [greenRedYellowResultTypeCategory.green]: Color.Green,
  [greenRedYellowResultTypeCategory.red]: Color.Red,
  [greenRedYellowResultTypeCategory.yellow]: Color.Yellow,
  [greenRedYellowResultTypeCategory.gray]: Color.Gray,
};

export interface OutcomeResultPillProps {
  size: Size;
  result: Pick<OutcomeResultDefinition, "label" | "category">;
  revenueAmount?: number | null;
}

/**
 * Renders a pill for an outcome result.
 * Use this when you already have the result object directly.
 */
export const OutcomeResultPill: FC<OutcomeResultPillProps> = (props) => {
  const { size, result, revenueAmount } = props;
  const pillColor = categoryToPillColor[result.category] ?? Color.Gray;

  const label =
    revenueAmount !== undefined &&
    revenueAmount !== null &&
    revenueAmount > 0 &&
    result.category === greenRedYellowResultTypeCategory.green
      ? `${result.label} — $${Math.round(revenueAmount).toLocaleString()}`
      : result.label;

  return <Pill size={size} color={pillColor} label={label} />;
};
